import React from "react";
import { motion } from "framer-motion";
import { FaUserTie, FaFlag, FaLandmark, FaBuilding } from "react-icons/fa";
import SectionHeading from "../SectionHeading";

// Milestones use only facts already stated on the site. Add real years here
// (e.g. `year: "2009"`) once they're confirmed; the timeline shows them if present.
const milestones = [
  {
    icon: FaUserTie,
    title: "The Founder",
    text: "26 years of rich experience in Civil Construction work.",
  },
  {
    icon: FaFlag,
    title: "Established",
    text: "Established 26 years ago, delivering reliability and client satisfaction.",
  },
  {
    icon: FaLandmark,
    title: "Recognised",
    text: "ISO 9001:2015 certified, and registered with various government and semi-government organizations.",
  },
  {
    icon: FaBuilding,
    title: "Today",
    text: "Today, M/S. R.C. Bidave Civil Contractors and Suppliers is a name to reckon on in the civil and mechanical industry. With 26 years of experience, the company has grown with an expanding client base. We specialize in repairs, rehabilitation, fabrication, and custom-built manufacturing. Our expertise has led to numerous esteemed projects and a strong track record.",
    highlights: [
      ["Experience", "26 years of industry experience"],
      ["Expertise", "Repairs, rehabilitation, fabrication"],
      ["Projects", "Numerous esteemed projects"],
    ],
  },
];

function WeAre() {
  return (
    <section id="we-are" className="scroll-mt-36 py-16 sm:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Our Journey" title="We Are" />

        <ol className="relative border-l-2 border-brand-navy/15 ml-5 sm:ml-6">
          {milestones.map(({ icon: Icon, title, text, year, highlights }, i) => (
            <motion.li
              key={title}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="relative pl-10 sm:pl-12 pb-10 last:pb-0"
            >
              <span
                className="absolute -left-[21px] sm:-left-[25px] top-0 flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-brand-navy text-brand-yellow ring-4 ring-white shadow-md"
                aria-hidden="true"
              >
                <Icon />
              </span>
              <div className="pt-1.5 sm:pt-2.5">
                {year && <p className="text-sm font-bold text-brand-navy-light">{year}</p>}
                <h3 className="text-lg sm:text-xl font-bold text-brand-navy">{title}</h3>
                <p className="mt-2 leading-relaxed text-gray-700">{text}</p>
                {highlights && (
                  <div className="mt-5 grid sm:grid-cols-3 gap-3">
                    {highlights.map(([label, value]) => (
                      <div key={label} className="h-full rounded-xl bg-brand-yellow/20 border border-brand-yellow/60 p-4">
                        <p className="font-bold text-brand-navy">{label}</p>
                        <p className="mt-1 text-sm text-gray-700">{value}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default WeAre;
